import { useMemo } from 'react'
import type { Player, TurnPermissions, TurnState } from '@/types/turn'
import type { TurnContextValue } from '../contexts'

interface UseTurnContextValueArgs {
  turnState: TurnState | null
  currentPlayer: Player | null | undefined
  permissions: TurnPermissions
  turnParticipants: Player[]
  adjustTime: (seconds: number) => void
  goToNextPlayer: () => void
  endTurn: () => void
  handleStartTurn: (config: { playerOrder: Player[]; timeLimit: number }) => void
  pauseTurn: () => void
  handleStartCountdown: () => void
  formatTime: (seconds: number) => string
}

/**
 * Empacota o estado de turnos como TurnContextValue.
 * Extraído de GameSession.tsx para reduzir ruído no orquestrador.
 */
export function useTurnContextValue(args: UseTurnContextValueArgs): TurnContextValue {
  const {
    turnState, currentPlayer, permissions, turnParticipants,
    adjustTime, goToNextPlayer, endTurn, handleStartTurn,
    pauseTurn, handleStartCountdown, formatTime,
  } = args

  return useMemo(() => ({
    turnState,
    currentPlayer: currentPlayer || null,
    permissions,
    players: turnParticipants,
    onAdjustTime: adjustTime,
    onNextPlayer: goToNextPlayer,
    onEndTurn: endTurn,
    onStartTurn: handleStartTurn,
    onPauseTurn: pauseTurn,
    onStartCountdown: handleStartCountdown,
    formatTime,
  }), [
    turnState, currentPlayer, permissions, turnParticipants,
    adjustTime, goToNextPlayer, endTurn, handleStartTurn,
    pauseTurn, handleStartCountdown, formatTime,
  ])
}
